import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {
    TextField,
    FormControl,
    FormLabel,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {DatePicker} from '@material-ui/pickers';
import {toSnakeCase} from '../locale/utils';

const Date = ({label, name, required, autocomplete, ...rest}) => {
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    return (
        <FormControl fullWidth error={!!error}>
            <FormLabel id={`${name}-label`} required={required}>
                {label}
            </FormLabel>
            <Controller
                render={props => (
                    <DatePicker
                        autoOk
                        allowKeyboardControl
                        inputFormat='MM/DD/YYYY'
                        labelId={`${name}-label`}
                        views={['year', 'month', 'date']}
                        {...rest}
                        renderInput={p => (
                            <TextField
                                {...p}
                                error={!!error}
                                inputProps={{
                                    ...p.inputProps,
                                    'data-cy': `form-field-${toSnakeCase(
                                        name
                                    )}`,
                                    autocomplete,
                                }}
                            />
                        )}
                        value={props.value || null}
                        onChange={moment =>
                            props.onChange(moment?.format('YYYY-MM-DD'))
                        }
                    />
                )}
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default Date;
